<template>
    <div class="brandIdBlock">
        <div
            class="brandId-row"
            v-for="shop in shopList"
            :key="shop.id">
            <el-image
                :src="shop.icon"
                style="width: 26px; height: 26px;  border-radius: 50%"
            ></el-image>
            <el-tooltip v-if="shop.channelIcon" :content="shop.channelName" style="margin: 0px -6px 0px 6px;">
                <el-image :src="shop.channelIcon" style="width: 18px; height: 18px;"></el-image>
            </el-tooltip>
            <span class="shop-title">{{ shop.shortTitle || shop.title }}</span>
            <el-select
                :value="valueMap[shop.id]"
                value-key="brandCode"
                name-key="name"
                :loading="loading[shop.id]"
                filterable
                remote
                :remote-method="($event) => remoteMethod($event, shop.id)"
                @change="(v) => selectChange(v, shop.id)"
                @visible-change="e => selectVisible(shop.id, e)"
                >
                <el-option
                    v-for="brandOp in brandOptions[shop.id]"
                    :key="brandOp.brandCode"
                    :label="brandOp.name"
                    :value="brandOp">
                </el-option>
            </el-select>
            <!-- <el-link 
                v-if="valueMap && valueMap[shop.id] && valueMap[shop.id].brandName || ''"
                style="margin-left: 8px" 
                @click="handleSetToShop(shop,valueMap && valueMap[shop.id] && valueMap[shop.id].brandName)"
                >应用到其他店铺</el-link
                >
            <span v-if="getFail[shop.id]" class="error-text">{{ getFail[shop.id] === true ? '店铺订购应用已过期，请重新订购以获取店铺品牌' : getFail[shop.id] }}</span> -->
        </div>
        <el-dialog-select-shop
            :visible.sync="shopDialogVisible"
            :shopData="shopList"
            :selected="selectShopIds"
            placeholder="店铺名称"
            @confirm="confirmSelectShop"
        ></el-dialog-select-shop>
        <!-- <div class="tips">注：京东官方要求部分类目的商品标题必须是商品的品牌词，不计入商品标题总字数<el-link href="https://jos.jd.com/platformdetail?listId=328&itemId=2215" target="_blank">查看平台公告</el-link></div> -->
    </div>
</template>

<script>
import { getJdmsBrandList,getVenderBrandListByshopId } from '@/servers/prod/center/jdms.js'
import { cloneDeep } from 'lodash';
import { ApplyToOtherShop } from '@/servers/prod/center/fxg.js';
const PLATFORMID = 'JdShop'
import { getApplyBrandConfig } from '@/servers/prod/center/pdd.js';
import { detailByBaseItemId } from '@/api/distributor';

export default {
    name: 'jdBrandIdBlock',
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        shopList: {
            type: Array,
            default() {
                return []
            }
        },
        value: {
            type: Array,
            default() {
                return []
            }
        },
        categoryIds: {
            type: Array,
            default() {
                return []
            }
        },
        baseItemId: [String, Number],
    },
    data() {
        return {
            valueMap: {},
            originOptions: {},
            brandOptions: {},
            loading: {},
            getFail: {},
            categoryId: '',
            shopDialogVisible:false,
            selectShopIds: '',
            applyShopName:'',//发货时效应用的店铺名称
            applyShopObj:[],//发货时效应用的店铺对象

        }
    },
    watch: {
        value: {
            immediate: true,
            handler(v) {
                if (v && v.length) {
                    v.forEach(item => {
                        this.$set(this.valueMap, item.shopId, item);
                    })
                }
            }
        },
        categoryIds: {
            handler(v) {
                this.categoryId = v.length > 3 ? v[2] : v[v.length - 1]
                this.$set(this, 'brandOptions', {});
            },
            immediate: true,
        },
    },
    methods: {
        extractContent(str) {
            // 使用正则表达式匹配括号内的内容
            const match = str.match(/（([^）]+)）/);

            // 如果匹配到括号内的内容，返回括号内的部分；否则，返回整个字符串
            return match ? match[1] : str;
        },
        method_validate() {
            let hasVoid = false;
            let getFail = {};
            this.shopList.forEach(shop => {
                if (!this.valueMap[shop.id]) {
                    hasVoid = true
                    getFail[shop.id] = '请选择品牌'
                }
            })
            this.getFail = getFail;
            return hasVoid
        },
        selectVisible(shopId, visible) {
            if(visible) {
                if (!this.brandOptions[shopId]) {
                    this.getShopBrandList(shopId)
                }
            } else {
                if (this.originOptions[shopId]) {
                    this.brandOptions[shopId] = cloneDeep(this.originOptions[shopId]);
                }
            }
        },
        selectChange(v, shopId) {
            console.log(cloneDeep(this.value), cloneDeep(v), cloneDeep(this.valueMap), '--this.value---v--this.valueMap-')
            let newVal = cloneDeep(this.value);
            let oindex = newVal.findIndex(({shopId}) => shopId === v.shopId)
            v.channel = this.shopList.find(shop => shop.id == shopId)?.channel || "KMERP"
            if (oindex > -1) {
                newVal.splice(oindex, 1, v)
            } else {
                newVal.push(v)
            }
            console.log(newVal,167);
            this.$emit('change', newVal)
        },
        remoteMethod(queryText, shopId) {
            queryText = (queryText || '').trim()
            if (!queryText) {
                this.brandOptions[shopId] = cloneDeep(this.originOptions[shopId]);
                return false;
            }
            this.getShopBrandList(shopId, queryText)
        },
        async getShopBrandList(id) {
            this.$set(this.loading, id, true)
            this.getFail = {};
            try {
                let list = await getJdmsBrandList(id)
                // let list = await getVenderBrandListByshopId({shopId: id, categoryId: this.categoryId, brandName})
                this.loading[id] = false;
                if (!list) {
                    this.$set(this.getFail, id, true)
                    list = []
                } else {
                    list = list.map(item => {
                        return {
                            shopId: id,
                            brandCode: item.propCode,
                            name: item.propName
                            // brandName: item.propName
                        }
                    })
                }
                
                this.$set(this.brandOptions, id, cloneDeep(list))
                if(!brandName) {
                    this.$set(this.originOptions, id, cloneDeep(list))
                }
            } catch (error) {
                console.log(error, '-----error')
            }
            
        },
        handleSetToShop(promiseConf,applyShopName){
            this.applyShopObj = promiseConf
            this.shopDialogVisible = true;
            this.applyShopName = applyShopName
        },
        getCategoryId() {
            let leafCategoryId = '';
            const categoryIds = this.categoryIds;
            if (categoryIds && categoryIds.length) {
                leafCategoryId = categoryIds[categoryIds.length - 1];
            }
            return leafCategoryId;
        },
        confirmSelectShop(shops){
        this.shopDialogVisible = false
            this.$confirm(`选中店铺将匹配品牌【${this.applyShopName}】，匹配后将覆盖原品牌值，未匹配到将跳过，是否确认`, '提示', {
                confirmButtonText: '确定',
                type: 'warning'
            }).then(async() => {
                const shopIds = shops.map(item=>item.id)
                const brandName = this.applyShopName? this.extractContent(this.applyShopName):''
                const params = {
                    shopType: PLATFORMID,
                    shopIds:shopIds.join(','),
                    categoryId: this.categoryId,
                    brandName,
                }
                const res = await this.getApplyToOtherShop(params)
                const dataKeys = Object.keys(res)
                // for(const key in this.valueMap){
                //     if(dataKeys.includes((key))){
                //     const shopInfo = res[key];
                //     this.valueMap[key] = {...shopInfo,shopId: key}
                //     }
                    
                // }
                    const newValue = []
                // 处理接口返回的数据
                for(const key in res){
                    const shopInfo = res[key];
                    this.valueMap[key] = { 
                        brandId: shopInfo.vid,
                        brandName: shopInfo.vvalue,
                        shopId: Number(key),
                        // channel: "KMERP"
                        }
                    newValue.push({
                        brandId: shopInfo.vid,
                        brandName: shopInfo.vvalue,
                        shopId: Number(key),
                    }) 

                }
                // 去除接口返回的数据，其他的按照之前的value处理即可
                this.value.map(item => {
                    const index = newValue.findIndex(({ shopId }) => shopId == item.shopId);
                    if (index == -1) {
                    newValue.push(item)
                    }
                })
                this.$emit('change',newValue)
                this.$message.success('更新品牌成功！')
                
            }).catch(() => {
                // this.$message.error('更新品牌失败！')
            });

        },
        async getApplyToOtherShop(payload){
            const params = {
                ...payload,
            }
            const res =  await ApplyToOtherShop(params)
            return res
        },
    },
}
</script>

<style lang="scss" scoped>
.brandId-row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}
.error-text {
    color: #F56C6C;
    font-size: 12px;
    margin-left: 10px;
}
</style>